// extracted by mini-css-extract-plugin
export default {"container":"_rwzWi","headerText":"_gFXF6"};